export default "__VITE_ASSET__DvJhWpk6__"